const SkeletonCard = () => {
  return (
    <div className="w-[300px] h-[300px] rounded mt-[20px] mx-auto flex-col bg-secondary-background  items-center flex justify-center p-5  page-loading">
      <div className="flex w-full animate-pulse justify-center  bg-primary-skeleton rounded h-[50px]"></div>
      <div className="flex w-full animate-pulse mt-8 flex-col justify-center gap-3">
        <div className="bg-primary-skeleton w-[200px] rounded h-[20px]"></div>
        <div className="bg-primary-skeleton w-[200px] rounded h-[20px]"></div>
        <div className="bg-primary-skeleton w-[200px] rounded h-[20px]"></div>
        <div className="bg-primary-skeleton w-[200px] rounded h-[20px]"></div>
      </div>
      <div className="rounded mt-10 w-[100px] animate-pulse bg-primary-skeleton h-[40px] flex justify-center items-center "></div>
    </div>
  )
}

export default SkeletonCard
